import react, { useContext, useEffect } from "react";
import { opneWeasisViewer } from "../../helpers/CommonUtility";
import PatientDetails from "./Components/Overlays/PatientDetails";
import StudyDetails from "./Components/Overlays/StudyDetails";
import SeriesDetails from "./Components/Overlays/SeriesDetails";
import { PrimaryButton } from "@fluentui/react";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";

const WeasisViewer = ({weasisPatientDetails, studyId }) => {
  useEffect(() => {
    console.log("view port patient details data : ", weasisPatientDetails);
  }, []);

  return (
    <>
      <PatientDetails
        viewportData={weasisPatientDetails}
        showForceReinference={false}
        forceReinference={false}
        reportDoneStatusState={false}
      />
      <StudyDetails viewportData={weasisPatientDetails} />
      <SeriesDetails
        viewportData={weasisPatientDetails}
        currentImage={0}
        totalImage={0}
      />

      <div style={{ display: "flex", flexDirection: "row" }}>
        <PrimaryButton
          text="Open Advance Viewer"
          style={{ marginLeft: "10px" }}
          onClick={() => {
            opneWeasisViewer(studyId);
          }}
        />
        <div style={{ marginLeft: "20px" }}>
          <p style={{ fontWeight: "1000" }}>
            Download Advance Viewer(Weasis):{" "}
            <a
              href="https://weasis.org/en/getting-started/download-dicom-viewer/"
              target="_blank"
              //style={{ color: "#ede2e2" }}
            >
              Link
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default WeasisViewer;
